var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.99984 18.3332C14.6022 18.3332 18.3332 14.6022 18.3332 9.99984C18.3332 5.39746 14.6022 1.6665 9.99984 1.6665C5.39746 1.6665 1.6665 5.39746 1.6665 9.99984C1.6665 14.6022 5.39746 18.3332 9.99984 18.3332Z","stroke":"#FF5A47","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M6.6665 10H13.3332","strokeLinecap":"round","className":"invert","strokeLinejoin":"round","key":1})]);
}

Minus.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
